module.exports = __webpack_public_path__ + "img/the-cottages-sign.060436c2.jpg";